import * as React from 'react';
import { PlayerIcon } from './Icons';
import * as styles from './VideoPreview.css';

export interface IVideoPreviewProps {
  url: string;
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

export function VideoPreview({ url, onClick }: IVideoPreviewProps) {
  return (
    <div className={styles['container']} style={{ backgroundImage: `url(${url})` }} onClick={onClick}>
      <PlayerIcon />
    </div>
  );
}
